export default __webpack_public_path__ + "static/media/37.0897deba.jpeg";